import { render, staticRenderFns } from "./revertPanelDialog.vue?vue&type=template&id=b27fb180&scoped=true&"
import script from "./revertPanelDialog.vue?vue&type=script&lang=js&"
export * from "./revertPanelDialog.vue?vue&type=script&lang=js&"
import style0 from "./revertPanelDialog.vue?vue&type=style&index=0&id=b27fb180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27fb180",
  null
  
)

export default component.exports